export const WHITE = '#FFFFFF'

export const BLACK = '#000000'

export const GREY_COLORS = {
	50: '#F2F2F2',
	100: '#E6E6E6',
	200: '#CCCCCC',
	300: '#B3B3B3',
	400: '#999999',
	500: '#808080',
	600: '#666666',
	700: '#4D4D4D',
	800: '#333333',
	900: '#191919'
}

export const PARKER_GOLDEN_COLORS = {
	50: '#FFF8F2',
	100: '#FFF1E4',
	200: '#FFE4C6',
	300: '#FFD6A4',
	400: '#FFC879',
	500: '#FFB91D',
	600: '#CA9100',
	700: '#956A00',
	800: '#644600',
	900: '#372500'
}

export const BRAND_BLUE_COLORS = {
	50: '#EEF0FF',
	100: '#DCE1FF',
	200: '#B9C3FF',
	300: '#90A3FF',
	400: '#6686FF',
	500: '#2868FF',
	600: '#0050D7',
	700: '#00399F',
	800: '#00266F',
	900: '#001342'
}

export const TEAL_COLORS = {
	50: '#C6FEFF',
	100: '#8CFDFF',
	200: '#00ECEE',
	300: '#00D6D9',
	400: '#00BEC0',
	500: '#00AAAC',
	600: '#008586',
	700: '#006465',
	800: '#004344',
	900: '#002627'
}

export const BLUE_COLORS = {
	50: '#EAF1FF',
	100: '#D5E3FF',
	200: '#A3C5FF',
	300: '#6CABFF',
	400: '#0091F8',
	500: '#0076CC',
	600: '#005EA4',
	700: '#00467D',
	800: '#002F57',
	900: '#001C38'
}

export const RED_COLORS = {
	50: '#FEEBEE',
	100: '#FECDD2',
	200: '#EF9A9A',
	300: '#E57373',
	400: '#EF5350',
	500: '#F44336',
	600: '#E53935',
	700: '#D32F2F',
	800: '#C62828',
	900: '#B71C1C'
}

export const ORANGE_COLORS = {
	50: '#FBE9E7',
	100: '#FFCCBC',
	200: '#FFAB91',
	300: '#FF8A65',
	400: '#FF7043',
	500: '#FF5722',
	600: '#F4511E',
	700: '#E64A19',
	800: '#D84315',
	900: '#BF360C'
}

export const GREEN_COLORS = {
	50: '#E8F5E9',
	100: '#C8E6C9',
	200: '#A5D6A7',
	300: '#81C784',
	400: '#66BB6A',
	500: '#4CAF50',
	600: '#43A047',
	700: '#388E3C',
	800: '#2E7D32',
	900: '#1B5E20'
}

export const PURPLE_COLORS = {
	50: '#F3E5F5',
	100: '#E1BEE7',
	200: '#CE93D8',
	300: '#BA68C8',
	400: '#AB47BC',
	500: '#9C27B0',
	600: '#8E24AA',
	700: '#7B1FA2',
	800: '#6A1B9A',
	900: '#4A148C'
}

export const COLORS = {
	black: BLACK,
	blue: BLUE_COLORS,
	brandBlue: BRAND_BLUE_COLORS,
	golden: PARKER_GOLDEN_COLORS,
	green: GREEN_COLORS,
	grey: GREY_COLORS,
	orange: ORANGE_COLORS,
	purple: PURPLE_COLORS,
	red: RED_COLORS,
	teal: TEAL_COLORS,
	white: WHITE
}